import { render } from "./DropdownSelect.vue?vue&type=template&id=46989453&scoped=true"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"

import "./DropdownSelect.vue?vue&type=style&index=0&id=46989453&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46989453"]])

export default __exports__